import { Box, Paper, Typography, useTheme, useMediaQuery } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LINE_COLORS = ["#1976d2", "#0288d1", "#9c27b0"];

function ChartTooltip({ active, payload, label, moneda }) {
  if (!active || !payload?.length) return null;

  return (
    <Paper sx={{ p: 1.5, boxShadow: 3 }}>
      <Typography variant="caption" fontWeight={700} display="block" mb={0.5}>
        Día {label}
      </Typography>
      {payload
        .filter((entry) => entry.value != null)
        .map((entry) => (
          <Typography key={entry.dataKey} variant="body2" sx={{ color: entry.color }}>
            {entry.name}: {moneda} {(parseFloat(entry.value) || 0).toFixed(2)}
          </Typography>
        ))}
    </Paper>
  );
}

export default function ComparacionMensualChart({ series, data, moneda }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const hasData = (data || []).some((row) =>
    (series || []).some((key) => row[key] != null && row[key] > 0)
  );

  if (!hasData) {
    return (
      <Paper variant="outlined" sx={{ p: 4, mb: 3, textAlign: "center" }}>
        <Typography color="text.secondary">
          No hay ventas en los 3 meses comparados para mostrar el gráfico.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Typography variant="subtitle1" fontWeight={700} mb={0.5}>
        Comparación acumulada día a día (mes seleccionado y 2 anteriores)
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" mb={2}>
        Acumulado de ventas del mes hasta cada día
      </Typography>
      <Box sx={{ width: "100%", height: isMobile ? 280 : 360 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 16, left: 8, bottom: isMobile ? 8 : 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="dia"
              tick={{ fontSize: isMobile ? 10 : 12 }}
              label={{ value: "Día del mes", position: "insideBottom", offset: -4, fontSize: 11 }}
            />
            <YAxis
              tick={{ fontSize: 11 }}
              tickFormatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v.toFixed(0))}
            />
            <Tooltip content={<ChartTooltip moneda={moneda} />} />
            <Legend
              wrapperStyle={{ fontSize: isMobile ? 11 : 12 }}
              iconType="line"
            />
            {(series || []).map((key, idx) => (
              <Line
                key={key}
                type="monotone"
                dataKey={key}
                name={key}
                stroke={LINE_COLORS[idx % LINE_COLORS.length]}
                strokeWidth={2}
                dot={false}
                connectNulls={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
}
